import {
  ADD_PRODUCT_FAILURE,
  ADD_PRODUCT_REQUEST,
  ADD_PRODUCT_SUCCESS,
  EDIT_PRODUCT_FAILURE,
  EDIT_PRODUCT_REQUEST,
  EDIT_PRODUCT_SUCCESS,
  GET_PRODUCTS_FAILURE,
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  PRODUCT_SAVED_RESET,
} from 'settings/product-listing/actions';
import { DELETE_STOCK_FAILURE, DELETE_STOCK_REQUEST, DELETE_STOCK_SUCCESS } from 'stocks/actions';

const initState = {
  products: [],
  errorMessage: '',
  isFetching: false,
  isPosting: false,
  isSaved: false,
  areProductsFetched: false,
  productTemplates: [],
  isDeleting: false,
};

function productsReducer(state = initState, action) {
  if (action && action.type) {
    switch (action.type) {
      case GET_PRODUCTS_REQUEST: {
        return {
          ...state,
          isFetching: true,
        };
      }
      case GET_PRODUCTS_SUCCESS: {
        return {
          ...state,
          products: action.response,
          isFetching: false,
          areProductsFetched: true,
          isDeleting: false,
          deletedItem: null,
        };
      }
      case GET_PRODUCTS_FAILURE: {
        return {
          ...state,
          isFetching: false,
          errorMessage: action.errorMessage,
        };
      }
      case ADD_PRODUCT_REQUEST: {
        return {
          ...state,
          isPosting: true,
        };
      }
      case ADD_PRODUCT_SUCCESS: {
        return {
          ...state,
          products: action.response ? [...state.products, action.response] : state.products,
          isPosting: false,
          isSaved: true,
        };
      }
      case ADD_PRODUCT_FAILURE: {
        return {
          ...state,
          isPosting: false,
          errorMessage: action.errorMessage,
        };
      }
      case PRODUCT_SAVED_RESET: {
        return {
          ...state,
          isSaved: false,
        };
      }
      case EDIT_PRODUCT_REQUEST: {
        return {
          ...state,
          isPosting: true,
        };
      }
      case EDIT_PRODUCT_SUCCESS: {
        const productsEdited = action.response ? state.products.map((product) => (product.id !== action.response.id ? product : action.response)) : state.products;

        return {
          ...state,
          products: productsEdited,
          isPosting: false,
          isSaved: true,
        };
      }
      case EDIT_PRODUCT_FAILURE: {
        return {
          ...state,
          isPosting: false,
          errorMessage: action.error.code === 403 ? 'You have no permission to do this action!' : action.errorMessage,
        };
      }

      case DELETE_STOCK_REQUEST: {
        return {
          ...state,
          isDeleting: true,
          deletedItem: action.params.productId,
        };
      }
      case DELETE_STOCK_SUCCESS: {
        const id = action.params.productId;
        const productsDelete = state.products.filter((product) => {
          if (product.id !== id) {
            return product;
          }
          return null;
        });
        return {
          ...state,
          products: productsDelete,
          isDeleting: false,
        };
      }
      case DELETE_STOCK_FAILURE: {
        return {
          ...state,
          isPosting: false,
          errorMessage: action.error.code === 403 ? 'You have no permission to do this action!' : action.errorMessage,
        };
      }
      default:
        return state;
    }
  }
  return state;
}

export default productsReducer;
